import { defineComponent as _defineComponent } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { computed, ref, onMounted } from 'vue'
import BulkUpdateWrapper from '@/components/common/BulkUpdateWrapper.vue'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { useActions, useGetters, useMutations } from 'vuex-composition-helpers'
import ProjectCreationSection from '@/components/project/ProjectCreationSection.vue'
import ProjectsList from '@/components/project/ProjectsList.vue'
import { bulkUpdateProject } from '@/api/jobs'


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkUpdateProjectForm',
  props: {
    buttonLabel: null,
    selectedJobs: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonLabel: string
  selectedJobs: JobJson[]
}





const loading = ref(true)
const jobsError = ref(false)
const savingJobs = ref(false)
const projectId = ref<string | null | undefined>()
let initialProjectId: string | null | undefined

const {
  getTotalPages,
  getPageForProjectId,
  getCurrentPage: currentProjectPage,
  getError: projectError,
} = useGetters('projects', [
  'getById',
  'getTotalPages',
  'getPageForProjectId',
  'getCurrentPage',
  'getError',
  'getAddJobError',
])

const { createProject, fetchProjects } = useActions('projects', [
  'createProject',
  'fetchProjects',
])

const {
  UPDATE_CURRENT_PAGE: updateCurrentProjectPage,
  UPDATE_SEARCH: updateSearch,
  CLEAR_ERROR_PROJECT: clearProjectError,
} = useMutations('projects', [
  'UPDATE_CURRENT_PAGE',
  'UPDATE_SEARCH',
  'CLEAR_ERROR_PROJECT',
])

onMounted(() => {
  const selectedProjectIds: Set<string | null> = new Set(
    props.selectedJobs.map((job) => job.project_id)
  )
  if (selectedProjectIds.size === 1) {
    initialProjectId = [...selectedProjectIds][0]
  }
  projectId.value = initialProjectId

  if (projectId.value) {
    updateCurrentProjectPage(getPageForProjectId.value(projectId.value))
  }
  loading.value = false
})

const hubId = computed(() => {
  return props.selectedJobs[0].hub_id
})
const hasChanges = computed(() => {
  return projectId.value !== initialProjectId
})
const showHint = computed(() => {
  return !projectId.value && initialProjectId === undefined
})

const isProjectSnackbarVisible = computed({
  get: () => !!projectError.value,
  set: (newValue) => {
    if (!newValue) {
      clearProjectError()
    }
  },
})

const totalProjectPages = computed(() => {
  return getTotalPages.value(hubId.value)
})

const page = computed({
  get: () => {
    return currentProjectPage.value
  },
  set: (newValue) => {
    updateCurrentProjectPage(newValue)
    projectId.value = initialProjectId
  },
})

const onSelect = async (selectedProjectId: string) => {
  projectId.value = selectedProjectId
}

const saveNewProject = async (projectName: string) => {
  const newProjectId = await createProject({
    projectName,
    ownerId: hubId.value,
  })

  if (!projectError.value) {
    await fetchProjects()
    updateSearch('')
    // The project list sorts by project creation time
    updateCurrentProjectPage(1)
    projectId.value = newProjectId
  }
}

const saveJobs = async () => {
  if (!projectId.value) {
    jobsError.value = true
    return
  }

  savingJobs.value = true
  try {
    await bulkUpdateProject(
      props.selectedJobs.map((job) => job.id),
      projectId.value
    )
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, { project_id: projectId.value })
    )
    emits('updated', {
      message: 'Project updated',
      updatedJobs,
    })
  } catch (err) {
    jobsError.value = true
  } finally {
    savingJobs.value = false
  }
}
const clearJobsSnackbar = () => (jobsError.value = false)
const dismiss = () => emits('dismiss')

return { __sfc: true,emits, props, loading, jobsError, savingJobs, projectId, initialProjectId, getTotalPages, getPageForProjectId, currentProjectPage, projectError, createProject, fetchProjects, updateCurrentProjectPage, updateSearch, clearProjectError, hubId, hasChanges, showHint, isProjectSnackbarVisible, totalProjectPages, page, onSelect, saveNewProject, saveJobs, clearJobsSnackbar, dismiss, BulkUpdateWrapper, ProjectCreationSection, ProjectsList }
}

})